var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 5,
    viewBox: "0 0 18 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.45437,
    cy: 2.54563,
    r: 2.45437,
    transform: "rotate(-90 2.45437 2.54563)",
    fill: "#556BB8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5481,
    cy: 2.54563,
    r: 2.45437,
    transform: "rotate(-90 15.5481 2.54563)",
    fill: "#556BB8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00125,
    cy: 2.54563,
    r: 2.45437,
    transform: "rotate(-90 9.00125 2.54563)",
    fill: "#556BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDots);
export default __webpack_public_path__ + "static/media/blue-dots.d4dad3665083b81918f1424216d155e2.svg";
export { ForwardRef as ReactComponent };